import { ExpeditionServices } from '@typings/entities/Expedition'
import toSelectOption from './toSelectOption'

const getExpeditionServiceOptions = (expeditionServices: ExpeditionServices[]) =>
  expeditionServices?.map(toSelectOption('id', 'name'))

export default getExpeditionServiceOptions
